import { defineMessages } from "react-intl";

const messages = defineMessages({
  currencyError: {
    id: "settings.customFields.createEditPane.fieldSetup.currency.error",
    defaultMessage: "Currency is required",
    description: "Settings Custom field - Currency error text",
  },
  currencyTitle: {
    id: "settings.customFields.createEditPane.fieldSetup.currency.title",
    defaultMessage: "Select Currency",
    description: "Settings Custom field - new monetary CF currency title",
  },
  customFieldPreviewHint: {
    id: "settings.customFields.createEditPane.fieldSetup.customFieldPreview.hint",
    defaultMessage:
      "Below is a <u>preview</u> of what your custom field will look like when adding or editing a record.",
    description: "Settings Custom field - create/edit - field setup Custom Field preview hint",
  },
  customFieldPreviewTitle: {
    id: "settings.customFields.createEditPane.fieldSetup.customFieldPreview.title",
    defaultMessage: "Preview your custom field",
    description: "Settings Custom field - create/edit - field setup Custom Field preview label",
  },
  error: {
    id: "settings.customFields.createEditPane.fieldSetup.name.error",
    defaultMessage: "Field name is required",
    description: "Settings Custom field - new cf name error text",
  },
  markUnique: {
    id: "settings.customFields.createEditPane.fieldSetup.markUnique",
    defaultMessage: "Values must be unique",
    description: "Mark custom field as unique title",
  },
  numericFormatTitle: {
    id: "settings.customFields.createEditPane.fieldSetup.numericFormat.title",
    defaultMessage: "Format",
    description: "Settings Custom field - new numeric CF format title",
  },
  placeholder: {
    id: "settings.customFields.createEditPane.fieldSetup.placeholder.placeholder",
    defaultMessage: "Pick something descriptive and unique to guide your team",
    description: "Settings Custom field - new cf placeholder placeholder",
  },
  placeholderTitle: {
    id: "settings.customFields.createEditPane.fieldSetup.placeholder.title",
    defaultMessage: "Placeholder text",
    description: "Settings Custom field - new cf placeholder title",
  },
  title: {
    id: "settings.customFields.createEditPane.fieldSetup.name.title",
    defaultMessage: "Name your field",
    description: "Settings Custom field - new cf name title",
  },
});

export default messages;
